import React, { useEffect, useState } from 'react';
import { createCancelSource, searchArtists } from '../services/spotifyService';

interface SearchSuggestionProps {
  input: string;
  isComponentVisible: boolean;
  setIsComponentVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setArtist: React.Dispatch<any>;
}

const SearchSuggestion: React.FC<SearchSuggestionProps> = ({
  input,
  isComponentVisible,
  setArtist,
  setIsComponentVisible
}) => {
  const [artistSuggestions, setArtistSuggestions] = useState<any[] | null>(null);
  const [seeMore, setSeeMore] = useState(false);

  useEffect(() => {
    if (!isComponentVisible) {
      setIsComponentVisible(true);
    }
  }, [input]);

  useEffect(() => {
    if (!input) {
      setArtistSuggestions(null);
      return;
    }
    // debounce so we search once per pause in typing instead of per keystroke,
    // and cancel the in-flight request when the input changes so a slow stale
    // response can't overwrite results for the newer input
    const source = createCancelSource();
    let stale = false;
    const timer = setTimeout(async () => {
      const response = await searchArtists(input, source.token);
      if (stale) {
        return;
      }
      setArtistSuggestions(response ? response.data.artists.items : null);
    }, 300);
    return () => {
      stale = true;
      clearTimeout(timer);
      source.cancel();
    };
  }, [input]);

  const onClickHandler = (artist: any) => {
    setArtist(artist);
  };
  return artistSuggestions !== null && artistSuggestions.length > 0 && isComponentVisible ? (
    <div className="absolute overflow-x-scroll max-h-96 top-0 right-0 left-0 z-50 text-center shadow">
      <div className="bg-white  ">
        <ul className="relative shadow-md rounded">
          {artistSuggestions.slice(0, seeMore ? 10000 : 5).map((artist: any) => {
            return (
              <button
                type="button"
                key={artist['external_urls']['spotify']}
                className="flex justify-start w-full py-2 hover:bg-gray-200"
                onClick={e => onClickHandler(artist)}
              >
                <div
                  className="bg-cover rounded-full h-7 w-7 mx-2 flex my-auto"
                  style={{
                    backgroundImage: `url(${artist.images.length ? artist.images[0].url : null})`
                  }}
                ></div>
                <p className="text-xs my-auto">{artist.name}</p>
              </button>
            );
          })}
          <button
            type="button"
            key={'seeMore'}
            className="w-full py-2 px-2"
            onClick={e => setSeeMore(!seeMore)}
          >
            {seeMore ? (
              <p className="text-xs my-auto font-light underline">show less</p>
            ) : (
              <p className="text-center text-xs my-auto font-light underline">
                show all {artistSuggestions.length}
              </p>
            )}
          </button>
        </ul>
      </div>
    </div>
  ) : (
    <></>
  );
};
export default SearchSuggestion;
